/** Parse a newline/comma-separated textarea value into a trimmed, non-empty list. */
export function parseEmailList(value: string): string[] {
  return value
    .split(/\n|,/)
    .map((entry) => entry.trim())
    .filter(Boolean)
}
